import { render, staticRenderFns } from "./SmsVars.vue?vue&type=template&id=df4359c4"
import script from "./SmsVars.vue?vue&type=script&lang=js"
export * from "./SmsVars.vue?vue&type=script&lang=js"
import style0 from "./SmsVars.vue?vue&type=style&index=0&id=df4359c4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports